import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgFor } from '@angular/common';
import { RevealOnScrollDirective } from '../../reveal-on-scroll.directive';
import { ExperienceSectionService } from './experience-section.service';

@Component({
  selector: 'app-experience-section',
  standalone: true,
  imports: [NgFor, RevealOnScrollDirective],
  templateUrl: './experience-section.component.html',
  styleUrl: './experience-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExperienceSectionComponent {
  get content() {
    return this.experienceService.content;
  }

  constructor(private readonly experienceService: ExperienceSectionService) { }
}
